module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-database-2.f8a932a2.svg";